import React, { useEffect, useState } from 'react';
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import { Get_Api } from '../Api_Url';
import ContentLoader from 'react-content-loader';
import GetSeodata from '../Components/GetSeodata';

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const [faqData, setfaqData] = useState([]);
  const [IsUploading, setIsUploading] = useState(false);
  const GetAllfaq = async () => {
    try {
      setIsUploading(true)
      const response = await Get_Api(`api/admin/GetAllFAQ`)
      setfaqData(response?.data)
      setIsUploading(false)
    } catch (error) {
      setIsUploading(false)
      console.log(error)
    }
  }

  useEffect(() => {
    GetAllfaq();
  }, []);


  return (
    <>
      <Navbar />
      <GetSeodata PageName={'faq'} />
      <div className='about-div'>
        <h1>FAQ</h1>
      </div>
      <div className='faq-div'>
        <br />
        {IsUploading ? (
        <ContentLoader
        height={'100%'}
        width={'100%'}
        viewBox="0 0 400 200"
        backgroundColor="#d9d9d9"
        foregroundColor="#ecebeb"
      >
        <rect x="15" y="15" rx="4" ry="4" width="130" height="10" />
        <rect x="155" y="15" rx="3" ry="3" width="130" height="10" />
        <rect x="295" y="15" rx="3" ry="3" width="90" height="10" />
        <rect x="15" y="50" rx="3" ry="3" width="90" height="10" />
        <rect x="115" y="50" rx="3" ry="3" width="60" height="10" />
        <rect x="185" y="50" rx="3" ry="3" width="200" height="10" />
        <rect x="15" y="90" rx="3" ry="3" width="130" height="10" />
        <rect x="160" y="90" rx="3" ry="3" width="120" height="10" />
        <rect x="290" y="90" rx="3" ry="3" width="95" height="10" />
        <rect x="15" y="130" rx="3" ry="3" width="130" height="10" />
        <rect x="160" y="130" rx="3" ry="3" width="225" height="10" />
      </ContentLoader>
        ) : (
          faqData?.map((item, index) => (
            <div className='faq-btn' key={index} >
              <button
                onClick={() => toggleAccordion(index)}
              >
                <span>{item?.Question}</span>
                <span style={{ fontSize: '20px', fontWeight: 'bold' }}>
                  {openIndex === index ? '-' : '+'}
                </span>
              </button>
              {openIndex === index && (
                <div className='faq-ans'>
                  {item?.Answer}
                </div>
              )}
            </div>
          ))
        )}
      </div>
      <br />
      <br />
      <Footer />
    </>
  )
}

export default FAQ